window.theme = window.theme || {};
theme.AlPdpDesktop = (() => {
  const metalName = value => ({gold: 'gold', or: 'gold', silber: 'silber', silver: 'silber', argent: 'silber', rose: 'rose', rosegold: 'rose', 'rose gold': 'rose', 'or rose': 'rose'})[String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim().toLowerCase()] || '';

  function state(product) {
    if (product.alPdpDesktop) return product.alPdpDesktop;
    const slides = Array.from(product.cache.mainSlider.querySelectorAll('.product-main-slide'));
    const gallery = product.container.querySelector('[data-product-images]');
    const breakpoint = window.matchMedia('(min-width: 901px)');
    const controls = new Map(slides.flatMap(slide => Array.from(slide.querySelectorAll('video')).map(video => [video, video.controls])));
    const data = JSON.parse(product.container.querySelector('[data-al-pdp-media-groups]')?.textContent || '{"options":[],"media":[]}');
    const media = new Map(data.media.map(item => [String(item.id), item.metal]));
    const groups = new Map(slides.map(slide => {
      const thumb = product.cache.thumbSlider.querySelector(`.product__thumb-item[data-index="${slide.dataset.index}"] [data-id]`);
      return [slide, {thumb: thumb?.closest('.product__thumb-item'), metal: media.get(slide.dataset.galleryMediaId || thumb?.dataset.id) || ''}];
    }));
    let optionIndex = data.options.findIndex(name => /^(farbe|farbe schmuck|farbe-schmuck|color|colour|couleur)$/i.test(name));
    if (optionIndex < 0) {
      optionIndex = [0, 1, 2].find(index => {
        const values = new Set((product.variants?.variants || []).map(variant => metalName(variant.options[index])).filter(Boolean));
        return values.size >= 2;
      }) ?? -1;
    }
    const colourFiltered = optionIndex >= 0 && data.media.some(item => item.metal);
    const filtered = colourFiltered || slides.some(slide => slide.dataset.galleryVariantImage === 'true');
    const onVariant = event => {
      product.alPdpDesktop.variant = event.detail.variant;
      const nextMetal = colourFiltered ? selectedMetal(product, event.detail.variant) : '';
      const nextImage = String(event.detail.variant?.featured_media?.id || '');
      if (filtered && (nextMetal !== product.alPdpDesktop.metal || nextImage !== product.alPdpDesktop.selectedMediaId)) product.initProductSlider(event.detail.variant);
    };
    if (filtered) product.container.addEventListener('variantChange', onVariant);
    const onBreakpoint = () => product.initProductSlider(filtered ? product.alPdpDesktop.variant : product.variants?.currentVariant);
    breakpoint.addEventListener('change', onBreakpoint);
    const header = document.getElementById('SiteHeader');
    const buybox = product.container.querySelector('.product-single__meta');
    const updateHeader = () => {
      const bottom = header ? Math.max(0, header.getBoundingClientRect().bottom) : 0;
      const top = Math.min(bottom + 20, window.innerHeight - buybox.getBoundingClientRect().height - 20);
      product.container.style.setProperty('--al-pdp-sticky-top', `${top}px`);
    };
    const observer = new ResizeObserver(updateHeader);
    if (header) observer.observe(header);
    observer.observe(buybox);
    window.addEventListener('scroll', updateHeader, {passive: true});
    product.alPdpDesktop = {slides, gallery, breakpoint, controls, groups, optionIndex, filtered, colourFiltered, onVariant, onBreakpoint, observer, updateHeader, mode: null, metal: '', selectedMediaId: '', visible: slides, mobileSlide: null, variant: product.variants?.currentVariant};
    updateHeader();
    return product.alPdpDesktop;
  }

  function selectedMetal(product, variant) {
    const s = product.alPdpDesktop;
    const value = variant?.options[s.optionIndex] || product.container.querySelector(`.variant-input-wrap[data-index="option${s.optionIndex + 1}"] input:checked`)?.value;
    return metalName(value);
  }

  function destroySlider(product, s) {
    s.slides.forEach(slide => {
      slide.querySelectorAll('video').forEach(video => video.pause());
      if (slide === s.mobileSlide) product.stopMediaOnSlide(slide);
    });
    if (product.flickity && typeof product.flickity.destroy === 'function') {
      product.flickity.destroy();
      product.flickity = null;
    }
    // Flickity lässt ausgefilterte Zellen ausserhalb des Viewports zurück.
    // Beim Wiederaufbau die ursprünglichen Elemente in ihre Reihenfolge bringen.
    s.slides.forEach(slide => product.cache.mainSlider.appendChild(slide));
  }

  function filteredSlider(product, s) {
    const change = index => {
      const slide = s.visible[index];
      if (!slide) return;
      if (s.mobileSlide) {
        s.mobileSlide.tabIndex = -1;
        product.stopMediaOnSlide(s.mobileSlide);
      }
      s.mobileSlide = slide;
      slide.tabIndex = 0;
      product.settings.currentSlideIndex = Number(slide.dataset.index);
      if (product.flickity) product.prepMediaOnSlide(slide);
    };
    product.settings.currentSlideIndex = Number(s.visible[0]?.dataset.index || 0);
    s.mobileSlide = null;
    if (!s.visible.length) return;
    // Bei Farb-/Variantenwechsel die vorhandene Flickity-Instanz behalten.
    // Nur Zellen und die native Vorschaubild-Navigation neu einlesen.
    if (product.flickity?.slideshow) {
      const slider = product.flickity.slideshow;
      product.flickity.refreshChildNav(0);
      slider.reloadCells();
      slider.emitEvent('cellChange', [0]);
      slider.resize();
      slider.select(0, false, true);
      product.flickity.childNavGoTo(0);
      product.flickity.updateChildArrows(0);
      change(0);
      return;
    }
    product.flickity = new theme.Slideshow(product.cache.mainSlider, {
      cellSelector: '.product-main-slide[data-al-visible="true"]',
      dragThreshold: 25, adaptiveHeight: true, avoidReflow: true, initialIndex: 0,
      childNav: product.cache.thumbSlider, childNavScroller: product.cache.thumbScroller,
      childVertical: product.cache.thumbSlider.dataset.position === 'beside',
      pageDots: true, wrapAround: true, alPdpFilter: true,
      callbacks: {onInit: () => queueMicrotask(() => change(0)), onChange: change}
    });
  }

  function prepare(product, variant) {
    const s = state(product);
    if (variant === undefined) variant = product.variants?.currentVariant;
    s.variant = variant;
    const grid = s.breakpoint.matches;
    s.gallery.dataset.alLayout = grid ? 'grid' : 'native';
    s.gallery.dataset.visibleMediaCount = String(s.slides.length);
    s.gallery.dataset.hasSlideshow = String(!grid && s.slides.length > 1);
    if (s.filtered) {
      if (s.mode !== (grid ? 'grid' : 'native')) {
        destroySlider(product, s);
      } else {
        s.slides.forEach(slide => slide.querySelectorAll('video').forEach(video => video.pause()));
        if (s.mobileSlide) product.stopMediaOnSlide(s.mobileSlide);
      }
      s.metal = s.colourFiltered ? selectedMetal(product, variant) : '';
      s.selectedMediaId = String(variant?.featured_media?.id || '');
      const variantSlides = product.getVariantGallerySlides(variant, s.slides);
      s.visible = s.metal
        ? variantSlides.filter(slide => s.groups.get(slide).metal === s.metal || slide.dataset.galleryMediaId === s.selectedMediaId).concat(variantSlides.filter(slide => !s.groups.get(slide).metal && slide.dataset.galleryMediaId !== s.selectedMediaId))
        : variantSlides;
      if (!s.visible.length && variantSlides.length) s.visible = [variantSlides[0]];
      const featured = s.visible.find(slide => s.groups.get(slide).thumb?.querySelector('[data-id]')?.dataset.id === String(variant?.featured_media?.id));
      if (featured) s.visible = [featured].concat(s.visible.filter(slide => slide !== featured));
      s.gallery.dataset.alMediaFilter = s.metal || 'all';
      s.gallery.dataset.visibleMediaCount = String(s.visible.length);
      s.gallery.dataset.hasSlideshow = String(!grid && s.visible.length > 1);
      s.slides.forEach(slide => {
        const visible = s.visible.includes(slide);
        slide.hidden = !visible;
        slide.dataset.alVisible = String(visible);
        slide.tabIndex = -1;
        slide.style.removeProperty('left');
        slide.style.removeProperty('transform');
        s.groups.get(slide).thumb?.classList.toggle('hide', !visible);
        slide.querySelectorAll('video').forEach(video => { video.controls = grid ? true : s.controls.get(video); });
      });
      const slideParent = !grid && product.flickity?.slideshow
        ? product.flickity.slideshow.slider : product.cache.mainSlider;
      s.visible.forEach(slide => {
        slideParent.appendChild(slide);
        const thumb = s.groups.get(slide).thumb;
        if (thumb) thumb.parentElement.appendChild(thumb);
      });
      if (!grid) filteredSlider(product, s);
      s.mode = grid ? 'grid' : 'native';
      return true;
    }
    if (!grid) {
      if (s.mode === 'grid') {
        if (variant?.featured_media) {
          const thumb = product.cache.thumbSlider.querySelector(`[data-id="${variant.featured_media.id}"]`);
          if (thumb) product.settings.currentSlideIndex = Number(thumb.dataset.index);
        }
        s.slides.forEach(slide => {
          slide.hidden = false;
          slide.querySelectorAll('video').forEach(video => { video.pause(); video.controls = s.controls.get(video); });
        });
      }
      s.mode = 'native';
      return false;
    }
    if (product.flickity && typeof product.flickity.destroy === 'function') {
      product.flickity.destroy();
      product.flickity = null;
    }
    let set = null;
    if (product.settings.imageSetName) {
      set = product.imageSetArguments(variant || product.variants?.currentVariant)?.imageSet;
    }
    s.slides.forEach(slide => {
      slide.hidden = !!set && slide.dataset.group !== set;
      slide.style.removeProperty('left');
      slide.style.removeProperty('transform');
      slide.tabIndex = slide.hidden ? -1 : 0;
      slide.querySelectorAll('video').forEach(video => { video.pause(); video.controls = true; });
    });
    s.mode = 'grid';
    return true;
  }

  function variantImage(product, variant) {
    const s = state(product);
    if (s.filtered) {
      if ((s.colourFiltered && selectedMetal(product, variant) !== s.metal) || String(variant?.featured_media?.id || '') !== s.selectedMediaId) product.initProductSlider(variant);
      if (!s.breakpoint.matches && product.flickity && variant?.featured_media) {
        const target = s.visible.findIndex(slide => s.groups.get(slide).thumb?.querySelector('[data-id]')?.dataset.id === String(variant.featured_media.id));
        if (target >= 0) product.flickity.goToSlide(target);
      }
      return true;
    }
    if (!s.breakpoint.matches) return false;
    if (variant?.featured_media) {
      const thumb = product.cache.thumbSlider.querySelector(`[data-id="${variant.featured_media.id}"]`);
      if (thumb) product.settings.currentSlideIndex = Number(thumb.dataset.index);
    }
    return true;
  }

  function zoom(container, target) {
    const images = Array.from(container.querySelectorAll('.photoswipe__image')).filter(image => {
      const slide = image.closest('.product-main-slide');
      return !slide.hidden && !slide.querySelector('[data-video-type], [data-product-media-type-model]');
    });
    const items = images.map(el => ({msrc: el.currentSrc || el.src, src: el.dataset.photoswipeSrc, w: Number(el.dataset.photoswipeWidth), h: Number(el.dataset.photoswipeHeight), el, initialZoomLevel: 0.5}));
    const clicked = target.closest('.product-main-slide').querySelector('.photoswipe__image');
    const product = container.closest('[data-al-pdp-standard]');
    if (product) product.alPdpZoomImages = images;
    return {items, index: Math.max(0, images.indexOf(clicked))};
  }

  function zoomChanged(product, index) {
    const s = product.alPdpDesktop;
    if (!s?.filtered) return false;
    const slide = product.container.alPdpZoomImages?.[index]?.closest('.product-main-slide');
    const mediaIndex = s.visible.indexOf(slide);
    if (product.flickity && mediaIndex >= 0) product.flickity.goToSlide(mediaIndex);
    return true;
  }

  function destroy(product) {
    const s = product.alPdpDesktop;
    if (!s) return;
    s.breakpoint.removeEventListener('change', s.onBreakpoint);
    s.observer.disconnect();
    window.removeEventListener('scroll', s.updateHeader);
    product.container.removeEventListener('variantChange', s.onVariant);
    product.alPdpDesktop = null;
  }
  return {prepare, variantImage, zoom, zoomChanged, destroy};
})();
